export default "__VITE_ASSET__DkdE3fQZ__"